import { CommonModule } from '@angular/common';
import {
  Component,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
} from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { BaseComponent } from '../../base.component';
import { BAC_PAGES, DOMAIN_TYPE, SCHEMA_TYPE } from '../../../constants';
import { AutoUnsubscribe } from '../../../Services/autoUnsubscribe.service';
import { SchoolApiService } from '../../../Services/schoolApi.service';
import { BAC_ACTIVITIES_MAIN_DATA } from './bacActivities.data';
import { UrlDetectorPipe } from '../../../Services/urlDetector.pipe';

@AutoUnsubscribe()
@Component({
  selector: 'app-bac-activities',
  standalone: true,
  imports: [RouterOutlet, CommonModule, UrlDetectorPipe],
  providers: [SchoolApiService],
  templateUrl: './bac-activities.component.html',
  styleUrl: './bac-activities.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BacActivitiesComponent extends BaseComponent {
  BAC_MAIN_ACTIVITIES_DATA = BAC_ACTIVITIES_MAIN_DATA;
  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef,
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
    this.schemaType = SCHEMA_TYPE.GENERAL;
    this.articleType = BAC_PAGES.ACTIVITIES.GENERAL;
  }

  /*BAC_MAIN_ACTIVITIES_DATA: ISchoolArticle[] = [];
  public start: number = 0;
  public limit: number = 6;
  public totalcount: number;

  constructor(
    override readonly schoolApiService: SchoolApiService,
    readonly cdr: ChangeDetectorRef
  ) {
    super(schoolApiService);
    this.domainType = DOMAIN_TYPE.BAC;
    this.schemaType = SCHEMA_TYPE.GENERAL;
    this.articleType = BAC_PAGES.ACTIVITIES.GENERAL;
  }

  ngOnInit(): void {
    this.schoolApiService
      .getSchoolArticles({
        domainType: this.domainType,
        schemaType: this.schemaType,
        filter: { articleType: this.articleType },
        isArchived: false,
        language: this.language,
        start: this.start,
        limit: this.limit,
      })
      .subscribe((data: IResponse<IList<ISchoolArticle>>) => {
        if (data.status) {
          this.totalcount = data.payload?.count || 0;
          this.BAC_MAIN_ACTIVITIES_DATA = this.mapArticles(
            data.payload?.list || []
          );
          this.cdr.detectChanges();
        }
      });
  }*/
}
